import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Link } from "react-router-dom";
import InfoBlock from "../../elements/info-block";
import Heading from "../../elements/heading";
import PrimaryLink from "../../elements/primary-link";
import IconLink from "../../elements/icon-link";
import SimpleLink from "../../elements/simple-link";
import BodyText from "../../elements/body-text";
import "./style.scss";
import { connect } from "react-redux";
import { LOGOUT, setUserInfoAction } from "../../redux/actions";
import { selectUserState } from "../../selectors/application";
import api from "../../utils/api";
import { getUserInfo } from "../../services/userService";
import { selectFile } from "../../utils/siteUtils";
import getSiteInfo from "../../utils/getSiteInfo";
let submitting = false;
const AccountMenu = ({ menuItems = [], titleType, titleBody, body, button, logoutButtonText, setUserInfo, logout, colabHeading, colabButton, editPhotoText, addPhotoText, removePhotoText, imageUploadFailed, user }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [profile, setProfile] = useState({});
  const mobileClassNames = classNames("account-menu", {
    "account-menu-is-open": isOpen
  });
  const [uploadFailed, setUploadFailed] = useState();
  const wrapperRef = useRef(null);
  const isOpenRef = useRef(isOpen);
  // const inputFile = useRef(null);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside.bind(this));
  }, [isOpenRef]);

  useEffect(() => {
    return document.removeEventListener("mousedown", handleClickOutside.bind(this));
  }, []);
  useEffect(() => {
    setProfile({
      userInitials: `${user?.firstName[0]}${user?.lastName[0]}`,
      imageSrc: user?.photoLink
    });
  }, [user]);

  const handleClickOutside = event => {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target) && isOpenRef) {
      setIsOpen(false);
    }
  };

  const onMenuToggle = () => {
    if (document.getElementById("acc-menu").nextElementSibling) {
      var elems = document.querySelectorAll("#acc-menu ~ div");

      for (var i = 0; i < elems.length; i++) {
        !isOpen ? (elems[i].style.display = "none") : (elems[i].style.display = "block");
      }
    }
    setIsOpen(!isOpen);
  };
  const isActiveTab = item => {
    if (typeof window === "undefined") {
      return false;
    } else {
      return item.fields.link.value.href === window.location.pathname;
    }
  };
  const onPhotoEditClick = async () => {
    if (!submitting) {
      setUploadFailed(false);
      const [uploadFile] = await selectFile();
      try {
        submitting = true;
        const resUpload = await api.user.upload(null, { uploadFile });
        const siteInfo = await getSiteInfo();
        if (resUpload?.obj) {
          const { clippedPath } = resUpload.obj;
          user.clippedPhotoLink = clippedPath;
          user.dateFormat = siteInfo.dateFormat;
          await api.user.update(null, user);
          const updatedUser = await getUserInfo();
          setUserInfo(updatedUser);
        }
      } catch (ex) {
        setUploadFailed(true);
      } finally {
        submitting = false;
      }
    }
  };

  const onRemoveClick = async () => {
    if (!submitting) {
      submitting = true;
      const siteInfo = await getSiteInfo();
      user.clippedPhotoLink = null;
      user.dateFormat = siteInfo.dateFormat;
      await api.user.update(null, user);
      const updatedUser = await getUserInfo();
      setUserInfo(updatedUser);
      submitting = false;
    }
  };

  const activeTab = menuItems.find(item => isActiveTab(item));
  const onLogoutClick = () => {
    logout();
  };
  return (
    <div className={mobileClassNames} ref={wrapperRef} id="acc-menu">
      <div className="account-menu-header" onClick={onMenuToggle}>
        <div className="account-menu-active">
          {activeTab && activeTab.fields.link.value.text}
          {!isOpen && (
            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
              <path d="M0 0h24v24H0V0z" fill="none" />
              <path d="M7 10l5 5 5-5H7z" />
            </svg>
          )}
          {isOpen && (
            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
              <path d="M0 0h24v24H0V0z" fill="none" />
              <path d="M7 14l5-5 5 5H7z" />
            </svg>
          )}
        </div>
      </div>
      <InfoBlock>
        <div className="account-menu-body">
          <div className="profile-image-container">
            <div className="circle">{profile.imageSrc ? <img src={profile.imageSrc} /> : profile.userInitials}</div>
            <div className="image-links-container">
              <PrimaryLink buttonText={profile.imageSrc ? editPhotoText?.value : addPhotoText?.value} colorScheme={"green"} callback={onPhotoEditClick} />
              {profile.imageSrc && <div className="vertical-line" />}
              {profile.imageSrc && <PrimaryLink id="remove-image-link" buttonText={removePhotoText?.value} colorScheme={"green"} callback={onRemoveClick} />}
            </div>
          </div>
          {uploadFailed && (
            <div className="image-fail">
              <BodyText html={imageUploadFailed.value} />
            </div>
          )}
          <div className="account-menu-items">
            {menuItems.map(menuItem => {
              const item = menuItem.fields.link.value;
              const classes = classNames("account-menu-item", {
                "account-menu-item-is-active": isActiveTab(menuItem)
              });
              return (
                <div className={classes} key={item.text}>
                  {item.linktype === "external" ? <a href={item.href}>{item.text}</a> : <Link to={item.href}>{item.text}</Link>}
                </div>
              );
            })}
          </div>
          <div className="account-menu-information">
            {titleBody && titleBody.value && <Heading type={titleType} html={titleBody} typographyClass="type-h4" />}

            {body && <BodyText html={body.value} />}

            {button && <PrimaryLink {...button.fields} />}

            <div className="colab-content">
              {colabHeading?.value && (
                <Heading
                  {...{
                    html: { value: `<span>${colabHeading.value}</span>` },
                    typographyClass: "type-h4"
                  }}
                />
              )}
              {colabButton?.fields && <IconLink {...{ ...colabButton.fields }} />}
            </div>

            {logoutButtonText && logoutButtonText?.value && (
              <div className="logout-link">
                <SimpleLink text={logoutButtonText?.value} callback={() => onLogoutClick()} />
              </div>
            )}
          </div>
        </div>
      </InfoBlock>
    </div>
  );
};

const mapStateToProps = state => ({
  user: selectUserState(state)
});
const mapDispatchToProps = dispatch => ({
  setUserInfo: data => dispatch(setUserInfoAction(data)),
  logout: (...args) => dispatch({ type: LOGOUT, ...args })
});
export default connect(mapStateToProps, mapDispatchToProps)(AccountMenu);

AccountMenu.propTypes = {
  menuItems: PropTypes.arrayOf(
    PropTypes.shape({
      fields: PropTypes.shape({
        link: PropTypes.shape({
          value: PropTypes.shape({
            text: PropTypes.string,
            href: PropTypes.string,
            linktype: PropTypes.oneOf(["internal", "external"])
          })
        })
      })
    })
  ),
  titleType: PropTypes.object,
  titleBody: PropTypes.object,
  button: PropTypes.object,
  logoutButtonText: PropTypes.shape({ value: PropTypes.string }),
  body: PropTypes.shape({ value: PropTypes.string })
};

AccountMenu.defaultProps = {
  menuItems: []
};
